import { AllRouteKeysT } from '@/routes/Routes.types';

export const TAB_MENU_LIST: AllRouteKeysT[] = [
    'home',
    'wardrobe',
    'planer',
    'suitcases',
];
